export default __webpack_public_path__ + "static/horizontal_loading-ad896fd91b14bd29aa2dd49d8d547adc.gif";